import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat.js';
import 'dayjs/locale/fr.js';
import 'dayjs/locale/es.js';
import fr from './assets/i18n/fr.json';
import es from './assets/i18n/es.json';
import en from './assets/i18n/en.json';

dayjs.extend(localizedFormat);

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: fr },
      es: { translation: es },
      en: { translation: en },
    },
    fallbackLng: 'en',
    supportedLngs: ['fr', 'en', 'es'],
    detection: {
      order: ['localStorage'],
      lookupLocalStorage: 'locale',
      caches: [],
    },
    interpolation: {
      escapeValue: false,
    },
  });

dayjs.locale(i18n.language);
i18n.on('languageChanged', (lng) => dayjs.locale(lng));

export default i18n;
